import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    borderColor: theme.colors.grey,
    borderWidth: 1,
    borderRadius: theme.spacings.sm,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.white,
  },
  text: {
    color: theme.colors.darkestGrey,
    textAlign: 'center',
    verticalAlign: 'auto',
  },
  fontAbz: {
    fontFamily: 'ABeeZeeRegular',
  },
  blankedWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacings.sm,
    flex: 1,
  },
});
